import { render, staticRenderFns } from "./CompanyGroup.vue?vue&type=template&id=bf09b116&"
import script from "./CompanyGroup.vue?vue&type=script&lang=ts&"
export * from "./CompanyGroup.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyGroup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports